<app-bread-crumb
	[Locations]="[{target : 'home', label : 'Home'},{target : '/whatIsBeachwatch/aboutBeachwatch', label : 'About Beachwatch'}]"
	current="Is it safe to swim?">
</app-bread-crumb>
<div class="nsw-container">
	<div class="nsw-layout">
		<main class="nsw-layout__main">
			<!-- START: Main content -->
			<div class="nsw-docs__box nsw-docs__box--large">
				<div class="content">
					<div class="subscribe-container">
						<div>
							<div class="subscribe-container-text">
								<h1>Is it safe to swim?</h1>
								<h4 style="font-weight:400">
									Make sure it's safe to swim before entering the water. Here
									are a few easy ways you can check to help you decide where and when to swim.
								</h4>
							</div>
							<div class="in-page-navigation">
								<div class="highlight-bar"></div>
								<div class="list">
									<h4>On this page</h4>
									<a class="link" [routerLink]="['./']" fragment="whyweforecast">
										<span class="label">Why water quality matters?</span>
									</a>
									<a class="link" [routerLink]="['./']" fragment="howweforecast">
										<span class="label">Why we forecast</span>
									</a>
									<a class="link" [routerLink]="['./']" fragment="waterqualityratings">
										<span class="label">Our water quality ratings</span>
									</a>
									<a class="link" [routerLink]="['./']" fragment="signsofpollution">
										<span class="label">Check for signs of pollution</span>
									</a>
									<a class="link" [routerLink]="['./']" fragment="checktheweather">
										<span class="label">When can I swim after rain?</span>
									</a>
								</div>
							</div>
						</div>
						<div>
							<div class="desktop-subscribe">

								<div class="nsw-card">
									<div class="nsw-card__content">
										<div class="nsw-card__title">
											<ng-container *ngTemplateOutlet="subscribe">
											</ng-container>
										</div>
										<div class="nsw-card__copy">
											<p>Sign up to daily emails for your favourite swim site or region and we'll help you decide when it's safe to enter the water</p>
										</div>
										<span class="material-icons nsw-material-icons" focusable="false"
											aria-hidden="true">east</span>
									</div>
								</div>
								<ng-template #subscribe>
									<a [routerLink]="subscribeLink"><span class="subscribe-label">Subscribe for updates for your swimming spot</span></a>
								</ng-template>
							</div>
						</div>

					</div>
					<div class="sub-content-container">

						<h2 id="whyweforecast">Why water quality matters?</h2>
						<p>
							Beachwatch monitors the water quality for a range of swim sites in New South Wales. Our monitoring shows
							that the water is clean enough for swimming at many of these swim sites, most of the time.
						</p>
						<p>
							Water quality can sometimes be affected by microbial and other pollution, especially after periods of heavy rainfall. 
							Pollution from stormwater and sewage overflows can cause higher levels of faecal contamination that makes water quality unsuitable for swimming. 
						</p>
						<p>
							Swimming in polluted water can expose you to disease-causing microorganisms which can make you unwell. 
							This pollution usually only lasts for a short period of time after heavy rain before it disperses, and the water is clean enough for swimming again.
							However, during and following extreme wet weather and flooding events, pollution can impact swim sites longer than usual. Even when microbial levels return to normal, there may still be a large amount of debris or other hazards, such as murky water, which pose a risk to water users.
						</p>
						
						<h2 id="howweforecast">Why we forecast</h2>
						<p>
							Water quality testing can tell us if the water is clean enough for swimming. However, standard field sampling and lab analysis techniques can take up to 72 hours between sampling the water and understanding if water quality is suitable for swimming. 
							<br/><br/>
							To provide real-time information Beachwatch developed a predictive model to overcome delays in reporting water quality. We provide forecasts with guidance on water quality to help you decide when and where to swim. Our forecasts are issued twice daily at 6 am and 1:30 pm and may be updated during the day if conditions change. 
							<br/><br/>
							Beachwatch forecasts predict the health risk to swimmers at monitored swim sites in New South Wales by modelling the relationship between bacterial contamination and rainfall. Pollution is reported as water quality ratings based on recent rainfall and any other reported pollution incidents that could affect water quality.							
						</p>

						<h2 id="waterqualityratings">Our water quality ratings</h2>
						<p>
							We generate water quality ratings by categorising water quality into colour indicators, based on predicted levels of microbial concentrations and associated health risks at each swim site. For each water quality rating, we advise that you follow the recommended action to protect your health.
						</p>
						<div class="nsw-table nsw-table--bordered" [tabindex]="0" style="margin-top: 1rem;">
							<table>
								<thead>
									<tr>
										<th width="33%">Water quality rating</th>
										<th width="33%">Advice</th>
										<th width="33%">Recommended action</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div class="tbl-td-div">
												<img class="icon"
													src="assets/images/WaterqualityForecastIndicator/Green.svg"
													width="32px" height="32px">
												<p style="margin-top:0px;">Pollution unlikely</p>
											</div>
										</td>
										<td class="text-td">
											<p>Water quality is suitable for swimming.</p>
										</td>
										<td class="text-td">
											<p>Enjoy your swim</p>
										</td>
									</tr>
									<tr>
										<td>
											<div class="tbl-td-div">
												<img class="icon"
													src="assets/images/WaterqualityForecastIndicator/Yellow.svg"
													width="32px" height="32px">
												<p style="margin-top:0px;">Pollution possible</p>
											</div>
										</td>
										<td class="text-td">
											<p>
												Caution advised for swimming. Water quality is usually suitable for
												swimming, but young children, elderly or those with certain health conditions may be at increased risk.
											</p>
										</td>
										<td class="text-td">
											<p>Consider delaying swimming until water quality improves</p>
										</td>
									</tr>
									<tr>
										<td>
											<div class="tbl-td-div">
												<img class="icon"
													src="assets/images/WaterqualityForecastIndicator/Red.svg"
													width="32px" height="32px">
												<p style="margin-top:0px;">Pollution likely</p>
											</div>
										</td>
										<td class="text-td">
											<p>Water quality is unsuitable for swimming.</p>
										</td>
										<td class="text-td">
											<p>Avoid swimming today</p>
										</td>
									</tr>
									<tr>
										<td>
											<div class="tbl-td-div">
												<img class="icon"
													src="assets/images/WaterqualityForecastIndicator/Unavailable.svg"
													width="32px" height="32px">
												<p style="margin-top:0px;">Forecast unavailable</p>
											</div>
										</td>
										<td class="text-td">
											<p>This site does not have daily forecast information.</p>
										</td>
										<td class="text-td">
											<p>Check for signs of pollution before swimming</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<h2 id="signsofpollution">Check for signs of pollution</h2>
						<p>
							Always check for visible signs of pollution before swimming. Signs of pollution include flowing drains, open lagoons, murky water, unpleasant odours, and litter and debris in the water.
						</p>

						<h2 id="checktheweather">When can I swim after rain?</h2>
						<p>
							Swim sites may be polluted by stormwater if it's rained during the last few days.
							<br/><br/>
							As a general precaution, we suggest you wait before swimming again to allow the pollution to disperse:
						</p>

							<ul>
								<li>At ocean beaches, avoid swimming during heavy rain, and for at least one day after.</li>
								<li>At estuaries and inland waterways, avoid swimming for up to three days after heavy rain.</li>
							</ul>							
						<p>
							<br>Check the <app-external-link target="_blank" text="Bureau of Meteorology"
								[link]="BOM_WEBSITE_URL"></app-external-link> for recent rainfall.
						</p>
						
						<div class="mobile-subscribe">
							<div class="nsw-card">
								<div class="nsw-card__content">
									<div class="nsw-card__title">
										<ng-container *ngTemplateOutlet="subscribe">
										</ng-container>
									</div>
									<div class="nsw-card__copy">
										<p>
											Sign up to daily emails for your favourite swim site or region and we'll help you decide when it's safe to enter the water
										</p>
									</div>
									<span class="material-icons nsw-material-icons" focusable="false"
										aria-hidden="true">east</span>
								</div>
							</div>
							<ng-template #subscribe>
								<a [routerLink]="subscribeLink">
									<span class="subscribe-label">Subscribe for updates to your swimming spot1</span>
								</a>
							</ng-template>
						</div>
					</div>
				</div>
			</div>
			<!-- END: Main content -->
		</main>
	</div>
</div>